import { db } from '../firebase';
import { 
  collection, 
  addDoc, 
  query, 
  where, 
  orderBy, 
  limit, 
  startAfter,
  getDocs,
  Timestamp 
} from 'firebase/firestore';

export const addLog = async ({ action, details, entity_type, entity_id, user_id, location = null }) => {
  try {
    const logsCollection = collection(db, 'logs');
    await addDoc(logsCollection, {
      action,
      details,
      entity_type,
      entity_id,
      user_id,
      location,
      timestamp: Timestamp.now()
    });
  } catch (error) {
    console.error('Error adding log:', error);
    throw error;
  }
};

export const getLogs = async (filters = {}, pageSize = 25, lastDoc = null) => {
  try {
    let q = collection(db, 'logs');
    const conditions = [];

    // Dodaj filtry
    if (filters.action) {
      conditions.push(where('action', '==', filters.action));
    }
    if (filters.entity_type) {
      conditions.push(where('entity_type', '==', filters.entity_type));
    }
    if (filters.entity_id) {
      conditions.push(where('entity_id', '==', filters.entity_id));
    }
    if (filters.user_id) {
      conditions.push(where('user_id', '==', filters.user_id));
    }
    if (filters.location) {
      conditions.push(where('location', '==', filters.location));
    }
    if (filters.from_date) {
      conditions.push(where('timestamp', '>=', Timestamp.fromDate(new Date(filters.from_date))));
    }
    if (filters.to_date) {
      conditions.push(where('timestamp', '<=', Timestamp.fromDate(new Date(filters.to_date))));
    }

    // Zawsze sortuj po timestamp malejąco
    conditions.push(orderBy('timestamp', 'desc'));
    
    // Dodaj limit
    conditions.push(limit(pageSize));

    // Jeśli mamy lastDoc, dodaj startAfter
    if (lastDoc) {
      conditions.push(startAfter(lastDoc));
    }

    // Utwórz query z wszystkimi warunkami
    q = query(q, ...conditions);

    const snapshot = await getDocs(q);
    
    const logs = [];
    snapshot.forEach((doc) => {
      logs.push({
        id: doc.id,
        ...doc.data(),
        timestamp: doc.data().timestamp.toDate().toISOString()
      });
    });

    return {
      logs,
      lastDoc: snapshot.docs[snapshot.docs.length - 1]
    };
  } catch (error) {
    console.error('Error getting logs:', error);
    throw error;
  }
};
